import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import { offerService } from '../../../lib/api/offer';
import { InfoIcon, Message } from '../../../lib/constants/messages';
import Base64ToPdf from '../../offers/base64/Base64ToPdf';

type Props = {
    openLegalDocModal: boolean;
    setOpenLegalDocModal: (key: boolean) => void;
    documentType?: 'VERIFIED-PRIVATE' | 'DEFAULT-PRIVATE';
    countryId?: string;
};

const LegalDocumentModal: React.FC<Props> = ({
    openLegalDocModal,
    setOpenLegalDocModal,
    documentType = 'VERIFIED-PRIVATE',
    countryId = '',
}) => {
    const [documentName, setDocumentName] = useState('');
    const [base64DocString, setBase64DocString] = useState('');

    const showLegalDocumentPDF: any = async () => {
        try {
            if (documentType === 'VERIFIED-PRIVATE') {
                const {
                    resultObject: { documentId, documentName },
                } = await offerService.getBase64DocString({
                    documentId: '00000000-0000-0000-0000-000000000000' as string,
                    documentType: documentType as string,
                });

                setDocumentName(documentName);
                setBase64DocString(documentId);
                // setOpenLegalDocModal(true);
            } else {
                const {
                    resultObject: { documentId, documentName },
                } = await offerService.getBase64DefaultDocumentString({
                    countryId: countryId,
                });

                setDocumentName(documentName);
                setBase64DocString(documentId);
                // setOpenLegalDocModal(true);
            }
        } catch (err: any) {
            if (err?.response?.status === 400) {
                if (err.response.data?.error?.message === Message.FileNotPresent) {
                    Swal.fire({
                        title: Message.DocumentNotPresent,
                        icon: InfoIcon,
                    });
                }

                setOpenLegalDocModal(false);
            }
        }
    };

    useEffect(() => {
        if (openLegalDocModal && !base64DocString) {
            showLegalDocumentPDF();
        }
    }, [openLegalDocModal]);

    return (
        <Modal
            backdrop="static"
            show={openLegalDocModal}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title className="modal-title text-start w-100 fw-600 fs-20" id="contained-modal-title-vcenter">
                    Terms of Service
                </Modal.Title>

                <button
                    type="button"
                    aria-label="Close"
                    title="Close"
                    onClick={() => {
                        setOpenLegalDocModal(false);
                    }}
                >
                    <i className="bi bi-x-lg fs-20"></i>
                </button>
            </Modal.Header>
            <Modal.Body className="lt-modal-body esign-pdf-height auto-width">
                <Base64ToPdf id={documentName} base64Data={base64DocString} />
            </Modal.Body>
        </Modal>
    );
};

export default LegalDocumentModal;
